
import { defineComponent, PropType } from "vue";
import { Widget } from "~/models/widget.model";

export enum WidgetMode {
  SHOW = 'show',
  EDIT = 'edit',
  ADD = 'add',
}

export default defineComponent({

  props: {
        title: { type: String, required: false },
        mode: { type: String as PropType<WidgetMode>, required: true},
        widget: { type: Object as PropType<Widget>, required: true},
        empty: { type: Boolean, default: false},
        padding: { type: Boolean, default: true },
        isHoverable: { type: Boolean, default: false},
        isActive: { type: Boolean, default: false}
  },

  computed: {
    gridStackAttributes() {
      return {
        id: this.widget.id,
        "gs-id": this.widget.id,
        "gs-x": this.widget.x,
        "gs-y": this.widget.y,
        "gs-w": this.widget.width,
        "gs-h": this.widget.height,
        "gs-min-w": this.widget.minWidth,
        "gs-min-h": this.widget.minHeight,
        "gs-type": this.widget.type
      };
    },

    contentClass(): Record<string, string | boolean> {
      return {
        'editable': this.editable,
        'showable': this.showable,
        'addable': this.addable,
        'is-hoverable': this.isHoverable,
        'no-padding': !this.padding, 
        'is-active': this.isActive
      }
    },
 
    editable() {
      return this.mode === WidgetMode.EDIT;
    },

    addable() {
      return this.mode === WidgetMode.ADD;
    },

    showable() {
      return this.mode === WidgetMode.SHOW;
    },

    hasFakeData() {
      return this.addable || this.editable;
    }
  }
})

